import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import closeIcon from '../../assets/images/close_1close.png';
import searchIcon from '../../assets/images/search-1.svg';
import { getInvitedUsersList, getUsersList } from '../../helpers/utils';
import { IBLSpinLoader } from '../../../IBLSpinLoader';
import * as sea from 'node:sea';
import { useDebounce } from '../../helpers/useDebounce';
import chevronFirst from '../../assets/images/chevron-first_1.svg';
import chevronLeft from '../../assets/images/chevron-left-2.svg';
import chevronRight from '../../assets/images/chevron-right_1.svg';

const InvitedUsers = ({ setFocused = () => {} }) => {
  const { t } = useTranslation('library');

  const [loading, setLoading] = useState(false);
  const [initialUsersList, setInitialUsersList] = useState([]);
  const [filteredUsersList, setFilteredUsersList] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [paginationData, setPaginationData] = useState(null);
  const [page, setPage] = useState(1);

  const handleInvitedUsersSuccessCallback = (data) => {
    setLoading(false);
    const invitedUsers = Array.isArray(data?.results) ? data.results : [];
    setInitialUsersList(invitedUsers);
    setFilteredUsersList(invitedUsers);
    setPaginationData({
      next_page: data?.next_page,
      previous_page: data?.previous_page,
      count: data?.count,
    });
  };

  const handleInvitedUsersErrprCallback = () => {
    setLoading(false);
    //
  };

  const handleSearch = () => {
    if (String(searchValue).length > 2) {
      const updatedUsersList = initialUsersList.filter((pre) =>
        String(pre.email).toUpperCase().includes(searchValue.toUpperCase())
      );
      setFilteredUsersList([...updatedUsersList]);
    } else {
      setFilteredUsersList([...initialUsersList]);
    }
  };

  //useDebounce(handleSearch, 200, [searchValue])

  useDebounce(
    () => {
      setFilteredUsersList([]);
      setInitialUsersList([]);
      setLoading(true);
      getInvitedUsersList(
        handleInvitedUsersSuccessCallback,
        handleInvitedUsersErrprCallback,
        page,
        searchValue
      );
    },
    200,
    [page, searchValue]
  );

  return (
    <div
      style={{ display: 'flex' }}
      className="modal users-settings-invited-users-list-modal"
    >
      <div className="w-layout-vflex modal-container users-settings-invited-users-list-modal-container">
        <div className="w-layout-hflex modal-header-3">
          <h3 className="modal-header-title-2">{t('Invited Users')}</h3>
          <div
            onClick={setFocused}
            data-w-id="10163293-6732-4106-4f02-7f1a091ba246"
            className="modal-close-wrapper-2"
          >
            <img src={closeIcon} loading="lazy" alt="" />
          </div>
        </div>
        <div className="w-layout-vflex modal-body-3 user-settings-modal-body">
          <div className="text-block-25">
            {t('Showing list of invited users pending confirmation')}
          </div>
          <div className="w-layout-hflex table-top-header-block">
            <div className="w-layout-hflex search-box-block all-whiten-in-dark-mode invited-users-list-search-box">
              <img
                src={searchIcon}
                loading="lazy"
                alt=""
                className="image-49 users-search-box-icon"
              />
              <div className="search-box-form-block w-form">
                <form
                  id="email-form-4"
                  name="email-form-4"
                  data-name="Email Form 4"
                  method="get"
                  data-wf-page-id="65aec9c9e13ed74d8bfffe77"
                  data-wf-element-id="10163293-6732-4106-4f02-7f1a091ba24f"
                >
                  <input
                    className="text-field-5 w-input"
                    name="name-5"
                    data-name="Name 5"
                    placeholder={t('Search invited users')}
                    type="text"
                    id="name-5"
                    value={searchValue}
                    onChange={(e) => {
                      setPage(1);
                      setSearchValue(e?.target?.value);
                    }}
                  />
                </form>
                <div className="w-form-done">
                  <div>
                    {t('Thank you! Your submission has been received!')}
                  </div>
                </div>
                <div className="w-form-fail">
                  <div>
                    {t('Oops! Something went wrong while submitting the form.')}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className={`w-layout-vflex table-container-2 ${
              loading ? 'loading' : ''
            }`}
          >
            <div className="w-layout-hflex table-header invited-users-table-header">
              <div className="table-block table-block-medium all-whiten-in-dark-mode invited-users-table-block">
                <h5 className="table-title">{t('EMAIL')}</h5>
              </div>
              <div className="table-block table-block-big all-whiten-in-dark-mode invited-users-table-block">
                <h5 className="table-title"></h5>
              </div>
            </div>
            {loading && <IBLSpinLoader size={40} containerHeight={'200px'} />}
            {filteredUsersList.length > 0 &&
              filteredUsersList.map((user, index) => (
                <div
                  key={`admin-invited-user-${index}`}
                  className="w-layout-hflex table-body-row greyish-bg-in-darkmode invited-users-table-row"
                >
                  <div className="table-block table-block-medium invited-users-table-block">
                    <div className="table-text">
                      {String(user.email).toLowerCase()}
                    </div>
                  </div>
                  <div className="table-block table-block-big invited-users-table-block">
                    <div className="table-text"></div>
                  </div>
                </div>
              ))}
            {!loading && filteredUsersList.length === 0 && (
              <p>{t('No record found')}</p>
            )}
          </div>
          {paginationData?.next_page || paginationData?.previous_page ? (
            <div className="w-layout-hflex-account-ui users-settings-pagination-block">
              <div className="w-layout-hflex-account-ui users-settings-pagination-container all-whiten-in-dark-mode">
                {!!paginationData?.previous_page &&
                  parseInt(paginationData?.previous_page) > 1 && (
                    <div
                      onClick={() => setPage(1)}
                      className="w-layout-hflex-account-ui table-pagination-btn greyish-bg-in-darkmode"
                    >
                      <img
                        src={chevronFirst}
                        loading="lazy"
                        alt=""
                        className="table-pagination-btn-icon"
                      />
                    </div>
                  )}
                {!!paginationData?.previous_page && (
                  <div
                    onClick={() =>
                      setPage(parseInt(paginationData?.previous_page))
                    }
                    className="w-layout-hflex-account-ui table-pagination-btn greyish-bg-in-darkmode"
                  >
                    <img
                      src={chevronLeft}
                      loading="lazy"
                      alt=""
                      className="table-pagination-btn-icon"
                    />
                  </div>
                )}
                <div className="w-layout-hflex-account-ui table-pagination-btn table-pagination-btn-active">
                  <h5 className="table-pagination-page-number primary-color-in-dark-mode">
                    {t('Page')} {page}
                  </h5>
                </div>
                {/*<div className="w-layout-hflex-account-ui table-pagination-btn greyish-bg-in-darkmode">
                <h5 className="table-pagination-page-number">2</h5>
              </div>
              <div className="w-layout-hflex-account-ui table-pagination-btn greyish-bg-in-darkmode hidden-xs">
                <h5 className="table-pagination-page-number">3</h5>
              </div>
              <div className="w-layout-hflex-account-ui table-pagination-btn table-pagination-btn-no-hover"><img
                src={moreHorizontal} loading="lazy" alt=""
                className="table-pagination-btn-icon table-pagination-btn-icon-disabled" /></div>
              <div className="w-layout-hflex-account-ui table-pagination-btn greyish-bg-in-darkmode">
                <h5 className="table-pagination-page-number">20</h5>
              </div>*/}
                {!!paginationData?.next_page && (
                  <div
                    onClick={() => setPage(parseInt(paginationData?.next_page))}
                    className="w-layout-hflex-account-ui table-pagination-btn greyish-bg-in-darkmode"
                  >
                    <img
                      src={chevronRight}
                      loading="lazy"
                      alt=""
                      className="table-pagination-btn-icon"
                    />
                  </div>
                )}

                {/*<div className="w-layout-hflex-account-ui table-pagination-btn greyish-bg-in-darkmode"><img
                  src={chevronLast}
                  loading="lazy" alt=""
                  className="table-pagination-btn-icon" />
                </div>*/}
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
};

export default InvitedUsers;
